module.exports = __webpack_public_path__ + "img/4.99468164.png";